// @generated by protoc-gen-es v2.6.3 with parameter "keep_empty_files=true,target=js+dts"
// @generated from file proto/model/booking/hotel/hotel_dietary_preference.proto (package carmen, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_proto_model_core_common } from "../../core/common_pb";
import { file_proto_model_feature_restaurant_food_types } from "../../feature/restaurant/food_types_pb";

/**
 * Describes the file proto/model/booking/hotel/hotel_dietary_preference.proto.
 */
export const file_proto_model_booking_hotel_hotel_dietary_preference = /*@__PURE__*/
  fileDesc("Cjhwcm90by9tb2RlbC9ib29raW5nL2hvdGVsL2hvdGVsX2RpZXRhcnlfcHJlZmVyZW5jZS5wcm90bxIGY2FybWVuIqwBChZIb3RlbERpZXRhcnlQcmVmZXJlbmNlEjQKEHJlc3RyaWN0aW9uX3R5cGUYASABKA4yGi5jYXJtZW4uRGlldGFyeVJlc3RyaWN0aW9uEhMKC2Rlc2NyaXB0aW9uGAIgASgJEioKCHNldmVyaXR5GAMgASgOMhguY2FybWVuLkFsbGVyZ2VuU2V2ZXJpdHkSGwoTYWx0ZXJuYXRpdmVfb3B0aW9ucxgEIAMoCUIwWi5naXRodWIuY29tL3l1bmFjYWJhL2Nhcm1lbi9wcm90by9tb2RlbC9ib29raW5nYgZwcm90bzM", [file_proto_model_core_common, file_proto_model_feature_restaurant_food_types]);

/**
 * Describes the message carmen.HotelDietaryPreference.
 * Use `create(HotelDietaryPreferenceSchema)` to create a new message.
 */
export const HotelDietaryPreferenceSchema = /*@__PURE__*/
  messageDesc(file_proto_model_booking_hotel_hotel_dietary_preference, 0);

